import React from "react";
import {
    Box,
    ClickAwayListener,
    Fade,
    Dialog,
    DialogActions,
    DialogContent,
    Typography,
} from "@mui/material";
import GreenButton from "../buttons/GreenButton";
import WarningIcon from '@mui/icons-material/Warning';


export default function EDLSubmissionWarningDialog(props) {
    const { open, onClose } = props


    return (
        <Dialog
            open={open}
            onClose={onClose}
            TransitionComponent={Fade}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{
                "& .MuiPaper-root": {
                    background: "rgba(0,0,0,0.9)",
                    width: "720px",
                    height: "220px",
                    border: "2px solid rgba(50, 180, 65, 1)",
                    borderRadius: "8px",
                    display: "flex",
                    flexDirection: "column"
                },
            }}
        >
            <ClickAwayListener onClickAway={onClose}>
                <Box>
                    <Box
                        width='100%'
                        display={'flex'}
                        justifyContent={'center'}
                        marginTop={'30px'}
                        sx={{flexDirection:'column'}}
                    >
                        <Typography color={'white'} component="span" variant="h6" align="center">
                            EDL Already Submitted
                        </Typography>
                    </Box>
                    <Box
                        width={'100%'}
                        display={'flex'}
                    >
                        <Box
                            width={'100%'}
                            display="flex"
                            flexDirection="row"
                            justifyContent="center"
                            px={3}
                        >
                            <WarningIcon style={{fill: "rgba(200,200,0,0.8)"}} sx={{ fontSize: 20 }} />
                            <Typography color={'rgba(200,200,0,0.8)'} variant="h7" align="center">
                                {`This EDL Name has previously been submitted, Please rename the EDL and try again.`}
                            </Typography>
                        </Box>
                    </Box>
                    <Box width={'100%'} display={'flex'} justifyContent={'center'}>
                        <Typography color={'rgba(200,200,0,0.8)'} variant="body2" align="center" sx={{ mt: 1, px: 3 }}>
                            Please contact support if a previously submitted EDL has been incorrectly named.
                        </Typography>
                    </Box>
                    <Box
                        width='100%'
                        display={'flex'}
                        justifyContent={'center'}
                        marginTop={'20px'}
                        marginBottom="30px"
                    >           
                        <GreenButton variant='contained' onClick={onClose} text='Close' style={{ backgroundColor: 'rgb(55, 88, 66)' }}/>
                    </Box>
                    
                </Box>
            </ClickAwayListener>
        </Dialog>
    );
}
